import script from "./topPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./topPanel.vue?vue&type=script&setup=true&lang=js"

import "./topPanel.vue?vue&type=style&index=0&id=983e915c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-983e915c"]])

export default __exports__